
import React from 'react';
import './Tag.css';

type TagProps = {
  type?: 'good' | 'warn' | 'bad' | 'neutral';
  children: React.ReactNode;
};

export const Tag: React.FC<TagProps> = ({ type = 'neutral', children }) => {
  return <span className={`qc-tag qc-tag-${type}`}>{children}</span>;
};
